import React from 'react'
import styled from '@emotion/styled'
import { keyframes } from '@emotion/react'

import Base from '../_Base'

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`

const Styled = styled(Base)`
  fill: currentColor;
  animation: ${spin} 0.6s linear infinite;
`

const Loader = (props) => (
  <Styled width="24" height="24" viewBox="0 0 100 100" {...props}>
    <path
      opacity="0.2"
      d="M50,0a50,50,0,1,0,50,50A50,50,0,0,0,50,0Zm0,88.92A38.92,38.92,0,1,1,88.918,50v0A38.918,38.918,0,0,1,50,88.92Z"
    />
    <path d="M69.443,16.317,74.978,6.73A49.707,49.707,0,0,0,50,0h0V11.08h0A38.736,38.736,0,0,1,69.443,16.317Z" />
  </Styled>
)

export default Loader
